import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { obtenirNumeroServeur } from '../../App_Code/Utils';
import { ActGlo } from '../../App_Data/ActionTypes';
import * as Actions from '../../Actions/GlobalActions';
import logo from '../../Img/Gmc_Blanc.svg';

const Objets = [
    { store: 'AdhStore', objet: 'Adh' },
    { store: 'CopStore', objet: 'Cop' },
    { store: 'DocStore', objet: 'Docs' },
    { store: 'MesStore', objet: 'Messages' },
    { store: 'ProStore', objet: 'Pro' },
    { store: 'SynStore', objet: 'Syn' },
];

class PageChargement extends Component {
    constructor(props) {
        super(props);

        /* 'fixed-nav' réserve la place au header, ce qui laisse une zone blanche disgracieuse
        Suppression de la classe du body de façon temporaire */
        document.body.classList.remove('fixed-nav');

        let nouvelleCop = false;
        let changementCopSel = false;

        if (props.location && props.location.state) {
            const { state } = props.location;
            nouvelleCop = state.nouvelleCop || false;
            changementCopSel = state.changementCopSel || false;
        }

        if (changementCopSel) {
            props.actions.changementCopSel(changementCopSel);
        } else if (nouvelleCop) {
            props.actions.ajoutCopro(nouvelleCop);
        } else {
            props.actions.chargementComplet();
        }
    }

    shouldComponentUpdate(nextProps) {
        const { location, history, actions } = this.props;
        if (nextProps.AdhStore.Adh === ActGlo.EN_COURS_DE_CHARGEMENT) return false;

        const estCompteVide = nextProps.AdhStore.Adh && nextProps.AdhStore.Adh.LsCopExts.length === 0;
        const chargementComplet =
            estCompteVide ||
            Objets.every(element => nextProps[element.store][element.objet] !== ActGlo.EN_COURS_DE_CHARGEMENT);

        if (chargementComplet) {
            /* 'fixed-nav' doit être remis dans dans le body */
            document.body.classList.add('fixed-nav');

            if (!estCompteVide) {
                actions.chargementArrierePlan();
            }

            const redirection = location.state && location.state.prevLocation ? location.state.prevLocation : '/';

            history.replace(redirection);
        }

        return chargementComplet;
    }

    render() {
        return (
            <div className="y100 center full-bg">
                <div className="breathing-effect">
                    <img
                        className="logo mb-3"
                        src={logo}
                        alt="Gérer ma copro"
                        aria-label={obtenirNumeroServeur()}
                        aria-hidden="true"
                    />
                    <p>
                        <i className="texte text-light">Chargement en cours...</i>
                    </p>
                </div>
            </div>
        );
    }
}
PageChargement.displayName = 'PageChargement';

function mapStateToProps({
    AdhStore, CopStore, ProStore, SynStore, DocStore, MesStore, VoteStore
}) {
    return {
        AdhStore,
        CopStore,
        ProStore,
        SynStore,
        DocStore,
        MesStore,
        VoteStore,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageChargement);



// WEBPACK FOOTER //
// ./src/components/App/PageChargement.js